function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "tommy0");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "tommy0"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  fill: "#ECECEB",
  points: "0 219.47 198.425 219.47 198.425 21.044 0 21.044"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  fill: "#040C2B",
  points: "40.3268 146.0901 37.6968 146.0901 37.6968 138.1131 27.4358 138.1131 27.4358 146.0901 24.8038 146.0901 24.8038 127.7721 27.4358 127.7721 27.4358 135.7481 37.6968 135.7481 37.6968 127.7721 40.3268 127.7721"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-3",
  fill: "#040C2B",
  points: "51.234 146.09 53.864 146.09 53.864 127.772 51.234 127.772"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  fill: "#040C2B",
  points: "67.2951 143.7258 75.5691 143.7258 75.5691 146.0898 64.6621 146.0898 64.6621 127.7718 67.2951 127.7718"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-5",
  fill: "#040C2B",
  points: "92.9069 130.134 85.7599 130.134 85.7599 135.211 92.9069 135.211 92.9069 137.576 85.7599 137.576 85.7599 146.09 83.1269 146.09 83.1269 127.772 92.9069 127.772"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-6",
  fill: "#040C2B",
  points: "102.119 146.09 104.749 146.09 104.749 127.772 102.119 127.772"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.8102,144.8274 C127.3662,145.9014 125.3802,146.3304 122.8302,146.3304 C117.2152,146.3304 113.0762,142.4094 113.0762,137.0384 C113.0762,131.6394 117.3212,127.5294 122.9092,127.5294 C125.0582,127.5294 126.5602,127.8794 129.4352,129.0884 L129.4352,131.7464 C127.2872,130.5654 125.0582,129.9464 122.8562,129.9464 C118.8802,129.9464 115.7892,132.9824 115.7892,136.9574 C115.7892,141.0394 118.8532,143.9134 123.2042,143.9134 C124.6272,143.9134 125.9172,143.5914 127.1802,143.1884 L127.1802,139.4284 L123.6592,139.4284 L123.6592,137.0654 L129.8102,137.0654 L129.8102,144.8274 Z",
  id: "Fill-7",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-9",
  fill: "#040C2B",
  points: "150.2257 130.134 142.4617 130.134 142.4617 135.669 149.9567 135.669 149.9567 138.031 142.4617 138.031 142.4617 143.726 150.4677 143.726 150.4677 146.09 139.8287 146.09 139.8287 127.772 150.2257 127.772"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.0978,135.7756 L163.7888,135.7756 C166.6118,135.7756 167.4168,134.3266 167.3908,132.7946 C167.3608,131.0746 166.3428,130.0286 163.7888,130.0286 L162.0978,130.0286 L162.0978,135.7756 Z M164.0838,127.7716 C167.7918,127.7716 170.1028,129.7326 170.1028,132.9016 C170.1028,135.0236 169.0028,136.6076 167.0388,137.3866 C168.7038,138.4876 169.7248,140.1806 171.1218,142.4636 C171.9008,143.7256 172.3588,144.3436 173.6218,146.0896 L170.4778,146.0896 L168.0608,142.3296 C165.6428,138.5696 164.5418,138.1396 163.1988,138.1396 L162.0978,138.1396 L162.0978,146.0896 L159.4648,146.0896 L159.4648,127.7716 L164.0838,127.7716 Z",
  id: "Fill-11",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-13",
  fill: "#040C2B",
  points: "37.7707 194.6662 35.7717 194.6662 35.7717 183.8402 35.7307 183.8402 31.4497 189.2232 31.1237 189.2232 26.8417 183.8402 26.8007 183.8402 26.8007 194.6662 24.8037 194.6662 24.8037 180.7612 26.6787 180.7612 31.2867 186.4702 35.9147 180.7612 37.7707 180.7612"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.2609,183.8606 C55.5489,182.8616 54.0809,182.4126 52.4689,182.4126 C49.2889,182.4126 46.9239,184.6756 46.9239,187.7346 C46.9239,190.8536 49.2079,193.0146 52.5519,193.0146 C54.1209,193.0146 55.8339,192.4646 57.4039,191.4446 L57.4039,193.6266 C56.0379,194.3396 54.5489,194.8496 52.3679,194.8496 C47.1489,194.8496 44.8649,190.8336 44.8649,187.9176 C44.8649,183.6766 48.0659,180.5776 52.4899,180.5776 C53.9169,180.5776 55.3649,180.9236 57.2609,181.7186 L57.2609,183.8606 Z",
  id: "Fill-15",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-17",
  fill: "#040C2B",
  points: "77.4655 194.6662 75.4665 194.6662 75.4665 183.8402 75.4265 183.8402 71.1445 189.2232 70.8185 189.2232 66.5365 183.8402 66.4965 183.8402 66.4965 194.6662 64.4985 194.6662 64.4985 180.7612 66.3735 180.7612 70.9815 186.4702 75.6105 180.7612 77.4655 180.7612"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-19",
  fill: "#040C2B",
  points: "86.9045 192.8723 93.1835 192.8723 93.1835 194.6663 84.9065 194.6663 84.9065 180.7613 86.9045 180.7613"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-21",
  fill: "#040C2B",
  points: "108.027 187.469 113.96 194.666 111.554 194.666 106.824 188.917 102.032 194.666 99.606 194.666 105.601 187.469 100.034 180.761 102.461 180.761 106.824 186.063 111.167 180.761 113.573 180.761"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-23",
  fill: "#040C2B",
  points: "128.6408 187.469 134.5738 194.666 132.1678 194.666 127.4378 188.917 122.6458 194.666 120.2198 194.666 126.2138 187.469 120.6478 180.761 123.0748 180.761 127.4378 186.063 131.7808 180.761 134.1868 180.761"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-25",
  fill: "#040C2B",
  points: "149.2545 187.469 155.1875 194.666 152.7815 194.666 148.0505 188.917 143.2595 194.666 140.8335 194.666 146.8275 187.469 141.2615 180.761 143.6875 180.761 148.0505 186.063 152.3945 180.761 154.7995 180.761"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-27",
  fill: "#040C2B",
  points: "167.7292 194.7883 167.3212 194.7883 161.3072 180.7613 163.3052 180.7613 167.4852 190.5273 171.6442 180.7613 173.6222 180.7613"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-29",
  fill: "#040C2B",
  points: "24.804 164.862 173.621 164.862 173.621 162.23 24.804 162.23"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-31",
  fill: "#040C2B",
  points: "31.925 47.467 26.607 47.467 26.607 51.258 31.741 51.258 31.741 52.877 26.607 52.877 26.607 56.779 32.091 56.779 32.091 58.398 24.803 58.398 24.803 45.848 31.925 45.848"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.2438,48.6076 C43.1768,47.5956 42.1458,47.3006 41.2998,47.3006 C40.1398,47.3006 39.3118,47.9086 39.3118,48.7916 C39.3118,51.2026 44.7408,51.1656 44.7408,55.1586 C44.7408,57.1286 43.2498,58.5636 41.2258,58.5636 C39.8638,58.5636 38.7598,58.1956 37.7108,57.4036 L37.7108,55.1226 C38.6318,56.2996 39.7908,56.9446 41.0238,56.9446 C42.4218,56.9446 43.0658,56.0606 43.0658,55.3616 C43.0658,52.7666 37.6378,52.4716 37.6378,49.0306 C37.6378,46.9886 39.1468,45.6816 41.4468,45.6816 C42.4038,45.6816 43.3608,45.9766 44.2438,46.5646 L44.2438,48.6076 Z",
  id: "Fill-32",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-33",
  fill: "#040C2B",
  points: "60.3322 47.467 55.9902 47.467 55.9902 58.398 54.1862 58.398 54.1862 47.467 49.8432 47.467 49.8432 45.848 60.3322 45.848"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2731,53.0793 L71.1751,53.0793 L69.1501,48.5343 L67.2731,53.0793 Z M75.4251,58.3973 L73.5851,58.3973 L71.9111,54.6993 L66.5741,54.6993 L64.9911,58.3973 L63.1511,58.3973 L68.5431,45.7733 L69.8131,45.7733 L75.4251,58.3973 Z",
  id: "Fill-34",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.84,56.7785 L85.103,56.7785 C87.22,56.7785 87.79,55.7295 87.79,54.7915 C87.79,53.6495 86.907,52.8405 85.011,52.8405 L82.84,52.8405 L82.84,56.7785 Z M82.84,51.2205 L84.036,51.2205 C85.821,51.2205 86.686,50.5585 86.686,49.2155 C86.686,48.2765 86.153,47.4665 84.496,47.4665 L82.84,47.4665 L82.84,51.2205 Z M81.036,45.8475 L84.68,45.8475 C87.385,45.8475 88.545,47.4665 88.545,49.0495 C88.545,50.3555 87.938,51.2025 86.631,51.7365 L86.631,51.7725 C88.508,52.1235 89.649,53.3555 89.649,55.0485 C89.649,56.5945 88.49,58.3975 85.343,58.3975 L81.036,58.3975 L81.036,45.8475 Z",
  id: "Fill-35",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-36",
  fill: "#040C2B",
  points: "97.6047 56.7785 103.2717 56.7785 103.2717 58.3975 95.8007 58.3975 95.8007 45.8475 97.6047 45.8475"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-37",
  fill: "#040C2B",
  points: "108.969 58.398 110.773 58.398 110.773 45.848 108.969 45.848"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.9284,48.6076 C122.8614,47.5956 121.8304,47.3006 120.9834,47.3006 C119.8244,47.3006 118.9964,47.9086 118.9964,48.7916 C118.9964,51.2026 124.4254,51.1656 124.4254,55.1586 C124.4254,57.1286 122.9344,58.5636 120.9104,58.5636 C119.5484,58.5636 118.4444,58.1956 117.3954,57.4036 L117.3954,55.1226 C118.3154,56.2996 119.4744,56.9446 120.7074,56.9446 C122.1064,56.9446 122.7504,56.0606 122.7504,55.3616 C122.7504,52.7666 117.3214,52.4716 117.3214,49.0306 C117.3214,46.9886 118.8304,45.6816 121.1314,45.6816 C122.0884,45.6816 123.0454,45.9766 123.9284,46.5646 L123.9284,48.6076 Z",
  id: "Fill-38",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-39",
  fill: "#040C2B",
  points: "141.4044 58.3977 139.6014 58.3977 139.6014 52.9317 132.5714 52.9317 132.5714 58.3977 130.7674 58.3977 130.7674 45.8477 132.5714 45.8477 132.5714 51.3127 139.6014 51.3127 139.6014 45.8477 141.4044 45.8477"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-40",
  fill: "#040C2B",
  points: "155.6129 47.467 150.2949 47.467 150.2949 51.258 155.4289 51.258 155.4289 52.877 150.2949 52.877 150.2949 56.779 155.7789 56.779 155.7789 58.398 148.4909 58.398 148.4909 45.848 155.6129 45.848"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.8688,56.7785 L166.7398,56.7785 C170.8248,56.7785 171.7638,53.6685 171.7638,52.1235 C171.7638,49.6015 170.1618,47.4665 166.6468,47.4665 L163.8688,47.4665 L163.8688,56.7785 Z M162.0648,45.8475 L166.9418,45.8475 C171.5798,45.8475 173.6218,49.1595 173.6218,52.1235 C173.6218,55.3425 171.1008,58.3975 166.9598,58.3975 L162.0648,58.3975 L162.0648,45.8475 Z",
  id: "Fill-41",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-42",
  fill: "#040C2B",
  points: "40.1139 95.4338 33.7749 95.4338 33.7749 111.3898 31.1419 111.3898 31.1419 95.4338 24.8029 95.4338 24.8029 93.0708 40.1139 93.0708"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.7082,109.2131 C69.8172,109.2131 72.8532,106.2321 72.8532,102.2301 C72.8532,98.2001 69.8172,95.2461 65.7082,95.2461 C61.6252,95.2461 58.5892,98.2001 58.5892,102.2301 C58.5892,106.2321 61.6252,109.2131 65.7082,109.2131 M65.7082,92.8281 C71.7512,92.8281 75.5652,97.1261 75.5652,102.2301 C75.5652,107.1731 71.8582,111.6301 65.6532,111.6301 C59.6642,111.6301 55.8772,107.1991 55.8772,102.2301 C55.8772,97.1521 59.7722,92.8281 65.7082,92.8281",
  id: "Fill-43",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-44",
  fill: "#040C2B",
  points: "107.5256 111.3899 104.8946 111.3899 104.8946 97.1259 104.8396 97.1259 99.1996 104.2179 98.7696 104.2179 93.1296 97.1259 93.0746 97.1259 93.0746 111.3899 90.4426 111.3899 90.4426 93.0709 92.9146 93.0709 98.9846 100.5919 105.0816 93.0709 107.5256 93.0709"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-45",
  fill: "#040C2B",
  points: "140.7892 111.3899 138.1572 111.3899 138.1572 97.1259 138.1022 97.1259 132.4622 104.2179 132.0322 104.2179 126.3912 97.1259 126.3382 97.1259 126.3382 111.3899 123.7052 111.3899 123.7052 93.0709 126.1772 93.0709 132.2472 100.5919 138.3452 93.0709 140.7892 93.0709"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-46",
  fill: "#040C2B",
  points: "170.4518 93.0705 173.6218 93.0705 166.8258 101.7185 166.8258 111.3895 164.1938 111.3895 164.1938 101.6925 157.3978 93.0705 160.5678 93.0705 165.4818 99.3825"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-47",
  fill: "#040C2B",
  points: "24.804 76.929 173.621 76.929 173.621 74.297 24.804 74.297"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-48",
  fill: "#BA001D",
  points: "198.425 219.47 396.85 219.47 396.85 21.044 198.425 21.044"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-49",
  fill: "#040C2B",
  points: "0 21.044 396.85 21.044 396.85 10.522 0 10.522"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-50",
  fill: "#040C2B",
  points: "0 10.522 396.85 10.522 396.85 0.001 0 0.001"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-51",
  fill: "#040C2B",
  points: "0 229.991 396.85 229.991 396.85 219.47 0 219.47"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-52",
  fill: "#040C2B",
  points: "0 240.514 396.85 240.514 396.85 229.992 0 229.992"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.828,207.068 L384.447,207.068 L384.447,33.446 L210.828,33.446 L210.828,207.068 Z M212.144,205.753 L383.132,205.753 L383.132,34.761 L212.144,34.761 L212.144,205.753 Z",
  id: "Fill-53",
  fill: "#FEFEFE"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-54",
  stroke: "#FEFEFE",
  strokeWidth: 1.315,
  points: "260.433 108.177 334.842 108.177 334.842 96.098 260.433 96.098"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-55",
  stroke: "#FEFEFE",
  strokeWidth: 1.315,
  points: "260.433 144.416 334.842 144.416 334.842 132.336 260.433 132.336"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-56",
  stroke: "#FEFEFE",
  strokeWidth: 1.315,
  points: "260.433 132.336 297.637 132.336 297.637 108.177 260.433 108.177"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-57",
  stroke: "#FEFEFE",
  strokeWidth: 1.315,
  points: "297.637 132.336 334.842 132.336 334.842 108.177 297.637 108.177"
})));

var SvgTommy0 = function SvgTommy0(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "397px",
    height: "241px",
    viewBox: "0 0 397 241",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTommy0, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tommy0.83053464.svg";
export { ForwardRef as ReactComponent };